import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import FormGroup from './FormGroup'
import { formatNumber } from '../../utils/utils'

const InputBlock = ( props ) => {
  const myRef = useRef(null)
  const inputFreeze = useSelector((state) => state.calculation.input.inputFreeze)
  const { name, value, onChange, status, unit, validationMethods, label, popoverText, containerProps } = props

  const handleChange = (e) => {
    onChange(name, e.target.value, status, validationMethods)
  }
  const handleBlur = (e) => {
    myRef.current.classList.remove('-focused')
  }
  const handleFocus = (e) => {
    myRef.current.classList.add('-focused')
  }

  return (
    <FormGroup ref={myRef} label={label} popoverText={popoverText}>
      <div className="inputGroup">
        <input tabIndex="0" type="text"
          name={name}
          maxLength={8}
          value={formatNumber(value)}
          disabled={inputFreeze}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...containerProps}
        />
        <span className="inputGroup__addon">{unit}</span>
        {status ?
          <label className='input-error is-visible'>{status}</label> : null
        }
      </div>
    </FormGroup>
  )
}
export default InputBlock
